// 호반건설 수면개선 PoC 엑셀 기반 정적 PSQI 데이터
// 키: 전구 S/N (대문자), 값: PSQI 점수
export const PSQI_BY_BULB_SN = {
  '85B80A': 11,
  'FCC57A': 10,
  '0BA14F': 14,
  'FCC581': 11,
  'FCC4ED': 7,
  'FCC4DD': 11,
  'FCC569': 15,
  'FCC580': 14,
  'FCC588': 12,
  'DB3AC9': 13,
  'FCC534': 12,
  'FCC422': 18,
  'FCC41A': 15,
  'FCC54E': 11,
  'FCC55A': 12,
  '6B2D15': 14,
  'C957F9': 11,
  '832172': 18,
  'FCC572': 11,
  'FCC44C': 13,
  'FCC7AA': 14,
  'FCC557': 12,
  'FCC5A0': 14,
  '6B2C4C': 13,
  'DE5540': 13,
  'FCC45A': 13,
  'FCC503': 14,
  'C4F4E7': 11,
  'FCC50E': 11,
  'FCC53B': 12,
};

// PSQI 점수 색상 반환 (높을수록 수면 나쁨)
export function psqiColor(score) {
  if (!score && score !== 0) return '#94a3b8';
  if (score <= 5) return '#10b981'; // 좋음 (초록)
  if (score <= 10) return '#f59e0b'; // 보통 (주황)
  return '#ef4444'; // 나쁨 (빨강)
}
